import { useState, useEffect } from 'react';
import { list2 } from '../../../services/Api'
import { Button, Select, MenuItem } from '@mui/material';
import moment from 'moment'

export const RefineryFilter = ({ type, init, callback }) => {
    const [units, setUnits] = useState([])
    const [regions, setRegions] = useState([])
    const [subRegions, setSubRegions] = useState([])
    const [countries, setCountries] = useState([])
    const [region, setRegion] = useState(init.region)
    const [subRegion, setSubRegion] = useState(init.subRegion)
    const [country, setCountry] = useState(init.country)
    const [unit, setUnit] = useState(init.unit)
    const [start, setStart] = useState(init.start)
    const starts = [...Array(6).keys()].flatMap((i) => {
        const year = moment().add(1,'year').subtract(i, 'year').format('YYYY')
        return [...Array(12).keys()].map((e) => moment(`${year}${12 - e}`, 'YYYYM').format('YYYY-MM-01'))
    })

    useEffect(() => {
        async function fetch () {
            const [regions, units] = await Promise.all([
                list2('region'),
                list2('unitGroup')
            ])
            setRegions(regions)
            setUnits(units.map(unit => unit.name))
        }
        fetch()
    }, [])

    useEffect(() => {
        setSubRegions(region.subRegions || [])
    }, [region])

    useEffect(() => {
        setCountries(subRegion.countries || [])
    }, [subRegion])

    const onSelectRegion = event => {
        setCountry('All')
        setSubRegion('All')
        setRegion(event.target.value)
    }

    const onSelectSubRegion = event => {
        setCountry('All')
        setSubRegion(event.target.value)
    }

    const onSelectCountry = event => {
        setCountry(event.target.value)
    }

    const onSelectUnit = event => {
        setUnit(event.target.value)
    }

    const onSelectStart = event => {
        setStart(event.target.value)
    }

    const confirm = () => {
        callback({ unit, region, subRegion, country, start, end: moment(start).add(12, 'month').format('YYYY-MM-01') })
    }
    return (
        <div className="row-start">
            <div className='row-between my-2'>
                <label className=''>Start Month</label>
                <Select value={start} onChange={onSelectStart}>
                    {starts.map((item) => (
                        <MenuItem key={`refinery_start_key_${item}`} value={item}>{moment(item).format('MMM YY')}</MenuItem>
                    ))}
                </Select>
            </div> 
            {type !== 'refinery:runs' && <div className='row-between my-2'>
                <label className=''>Unit</label>
                <Select value={unit} onChange={onSelectUnit}>
                    {units.map(unit => (
                        <MenuItem key={`refinery_unit_key_${unit}`} value={unit}>{unit}</MenuItem>
                    ))}
                </Select>
            </div> }
            <div className='row-between my-2'>
                <label className=''>Region</label>
                <Select value={region} onChange={onSelectRegion}>
                    <MenuItem value="All">Global</MenuItem>
                    {regions.map(region => (
                        <MenuItem key={`refinery_region_key_${region.id}`} value={region}>{region.name}</MenuItem>
                    ))}
                </Select>
            </div> 
            { subRegions.length > 0 && <div className='row-between my-2'>
                <label className=''>Sub-Region</label>
                <Select value={subRegion} onChange={onSelectSubRegion}>
                    <MenuItem value="All">All</MenuItem>
                    {subRegions.map(subRegion => (
                        <MenuItem key={`refinery_subRegion_key_${subRegion.id}`} value={subRegion}>{subRegion.name}</MenuItem>
                    ))}
                </Select>
            </div> } 
            { countries.length > 0 && <div className='row-between my-2'>
                <label className=''>Country</label>
                <Select value={country} onChange={onSelectCountry}>
                    <MenuItem value="All">All</MenuItem>
                    {countries.map(country => (
                        <MenuItem key={`refinery_country_key_${country.id}`} value={country}>{country.name}</MenuItem>
                    ))}
                </Select>
            </div> }
            <div className='row-center mt-6'>
                <Button variant='outlined' onClick={confirm} className='ml-2'>Confirm</Button >
            </div>
        </div>
    )
}
